<template>
  <a-modal
    title="申请退款"
    :width="600"
    :dialog-style="{ top: '20px' }"
    :maskClosable="false"
    :keyboard="false"
    :visible="visible"
    :footer="null"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <p v-if="eventApplyInfo.event">活动： {{eventApplyInfo.event.eventName}}</p>
    <p v-if="eventApplyInfo.categoryParent">赛项： {{eventApplyInfo.categoryParent.name}}</p>
    <p v-if="eventApplyInfo.category">组别： {{eventApplyInfo.category.name}}</p>
    <p>订单号：{{ orderInfo.orderNo }}</p>
    <p>金额：{{ orderInfo.payPrice / 100 }}</p>
    <p>请填写退款理由：</p>
    <a-textarea v-model="comment"> </a-textarea>

    <a-button
      type="primary"
      style="display: block; margin: 20px auto; width: 200px"
      size="large"
      @click="handleOk"
      :disabled="canRefund"
      >确认申请退款</a-button
    >
  </a-modal>
</template>

<script>
import { getAction, postAction } from "@/api/manage";
export default {
  name: "RefundModal",
  mixins: [],
  components: {},
  data() {
    return {
      visible: false,
      orderInfo: {},
      eventApplyInfo: {},
      comment: "",
      canRefund: true
    };
  },
  created() {},
  methods: {
    refund(order) {
      this.visible = true;
      this.orderInfo = order;
      console.log(order);
      this.getEventApplyInfo(this.orderInfo.eventApplyIds)
    },
    getEventApplyInfo(id){
      getAction("/teaching/teachingEventApply/getApplyInfo?eventApplyId="+id).then(res=>{
        if(res.success){
          this.eventApplyInfo = res.result
          if(this.eventApplyInfo.event && this.eventApplyInfo.event.applyConfig){
            let applyConfig = JSON.parse(this.eventApplyInfo.event.applyConfig)
            //退款查询
            if(applyConfig.canRefund==1 && applyConfig.canRefundBegin && applyConfig.canRefundEnd){
              let now = res.timestamp
              let begin = new Date(applyConfig.canRefundBegin).getTime()
              let end = new Date(applyConfig.canRefundEnd).getTime()
              if( begin < now && end > now){
                this.canRefund = false
              }
            }
          }
        }else{
           this.$message.info(res.message);
        }
      })
    },
    handleOk() {
      if(!this.orderInfo) return;
      if(this.comment  == ""){
        this.$message.info("请填写退费原因");
        return
      }
      if(this.canRefund){
        this.$message.info("未开放退费");
        return;
      }
      getAction("/teaching/teachingOrder/refundApply",{orderNo: this.orderInfo.orderNo, comment: this.comment}).then(res=>{
        this.$message.info(res.message);
        this.visible = false
        this.$emit("ok")
      })
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
</style>